import Vue from "vue"
import App from "./App.vue"
import vuetify from "./plugins/vuetify";
import router from "@/plugins/router";
import qs from "qs";
import '@mdi/font/css/materialdesignicons.css'
// import {$axios} from "@/plugins/axios2";
import {request} from "@/plugins/axios/index.js";
import {$dateFormat, $deepClone, $div, $format, $numberSplit} from "@/plugins/common";


Vue.config.productionTip = false

Vue.prototype.$qs = qs;
// 在main.js中把实例化的vue对象放在vue的原型上
Vue.prototype.$bus = new Vue();
// Vue.prototype.$axios = $axios;
Vue.prototype.$axios = request;
Vue.prototype.$format = $format;
Vue.prototype.$dateFormat = $dateFormat;
Vue.prototype.$deepClone = $deepClone;

Vue.filter("dateFormat", $dateFormat);
Vue.filter("div", $div);
Vue.filter("numberSplit", $numberSplit);

new Vue({
    vuetify,
    router,
    render: h => h(App)
}).$mount("#app")

